// STATE
interface State {
    inheritBypass: boolean;
}

// INITIAL STATE
const state: State = {
    inheritBypass: false
};

const getters = {
    isInheritBypass: (state: State) => {
        return state.inheritBypass;
    },
};

const mutations = {
    uiSetInheritBypass: (state: State, payload: any) => {
        state.inheritBypass = true;
    },
    uiUnSetInheritBypass: (state: State, payload: any) => {
        state.inheritBypass = false;
    }
};

// EXPORTS
export default {
    state,
    getters,
    mutations,
};